import * as React from 'react';
import Paper from '@mui/material/Paper';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { red, grey } from '@mui/material/colors';
import ParentBox from '../components/ParentBox';
import { repeatEffect, settingsConfig, toFormatedDateMinHour } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import defColors from 'utils/defColors';

const ProcessDataBox = ({ item, styleColor, sx }) => {
    const iconDef = {
        sx: {
            transform: 'scale(1.5)'
        }
    }

    return (
        <Paper elevation={3} sx={{ p: 2, minWidth: 280, ...sx }}>
            <Stack
                justifyContent="center"
                spacing={1}
            >
                <Paper variant="outlined" sx={{ position: 'relative', p: 2, pl: 4, pr: 4, backgroundColor: styleColor }}>
                    <Stack direction={'row'}
                        justifyContent="flex-start"
                        alignItems="center" spacing={2}>
                        <SyncAltIcon {...iconDef} />
                        <Typography variant="h5">{item.displayName}</Typography>
                    </Stack>
                </Paper>
                <Stack
                    direction={'column'}
                    justifyContent="center"
                    alignItems="center"
                    spacing={-2}>
                    <Typography variant='h5' textAlign={'center'} p={1} color={item.value === '0' && red[700]}>{item.displayText}</Typography>
                    <Typography variant='h6' textAlign={'center'} p={1} color={grey[500]}>{item.displayCount}</Typography>
                </Stack>
            </Stack>
        </Paper>
    )
}

const getProcTypeName = (procType) => {
    if (procType.startsWith("C"))
        return procType.replace("C", "연계서버")
    else if (procType.startsWith("O"))
        return procType.replace("O", "가공서버")
    else if (procType.startsWith("S"))
        return procType.replace("S", "제공서버")
    else
        return "알수없음"
}

const getProcActiveName = (procActive) => {
    if (procActive.startsWith("1"))
        return "정상"
    else if (procActive.startsWith("2"))
        return "대기"
    else
        return "장애"
}

export const  PopupViewBisSvrStat = () => {
    const [currentData, setCurrentData] = React.useState()

    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("newdashboard/gis/GetServerProcessStatus");
                if (response.status === 200) {
                    const data = response.data;

                    const dataSelect = data.rows.map(p => ({
                        procType: p.procType,
                        value: p.active,
                        displayName: getProcTypeName(p.procType),
                        displayText: `${getProcActiveName(p.active)}`,
                        displayCount: `${p.state}건`,
                    }))

                    setCurrentData(
                        {
                            updateDate: data.updateDate,
                            group1: dataSelect.filter(p => p.procType.startsWith("C")),
                            group2: dataSelect.filter(p => p.procType.startsWith("O")),
                            group3: dataSelect.filter(p => p.procType.startsWith("S")),
                        }
                    )
                    //col_PROC_TYPE: 'C1', col_ACTIVE: '1'
                }
            },
            settingsConfig().contentUpdateDelaySec)
    }, []);

    return (
        <div className='popup_dtprcs' style={{ background: 'linear-gradient(136deg,rgb(2 6 20)  0%, rgb(28 28 35) 68%)', overflow: 'hidden', color: 'white', width: '1680px', height: '780px', borderRadius: '26px', padding: '40px' }}>
        {currentData &&
            <Stack sx={{ height: '100%', width: '100%' }}
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}>
                <Stack
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={3}>
                    {
                        currentData?.group1?.map((p, idx) => <ProcessDataBox key={idx} styleColor={defColors.serverStatus[0]} item={p} />)
                    }
                </Stack>
                <Box sx={{ width: '10%' }}>
                    <LinearProgress />
                </Box>
                <Stack
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={6}>
                    {
                        currentData?.group2?.map((p, idx) => <ProcessDataBox key={idx} styleColor={defColors.serverStatus[1]} item={p} />)
                    }
                </Stack>
                <Box sx={{ width: '10%' }}>
                    {/* <LinearProgress sx={{ transform: 'scaleX(-1)' }} /> */}
                    <LinearProgress />
                </Box>
                <Stack
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={6}>
                    {
                        currentData?.group3?.map((p, idx) => <ProcessDataBox key={idx} styleColor={defColors.serverStatus[2]} item={p} />)
                    }
                </Stack>
            </Stack>
        }
        </div>
    )
}